module.exports = __webpack_public_path__ + "media/images/tailwind/search-icon-2-d9dbc9fd2d7598ffa66528e0713cbbd8.png";